/**
 * MSR activation fix 5 (QA test 2026-10-10). Kept out of DateRangePicker.tsx so form tests that mock the picker
 * still get the real rule.
 */
import type { DateRange } from "./DateRangePicker";

/**
 * The end date and time a save should use. An EMPTY end date means the same day as the start (matching the create
 * wizard), with the entered end time; an all-day event ends at 23:59 of its last day. Returns null when there is no
 * start date. Callers add the timezone offset.
 */
export function resolveEndDateTime(
  dateRange: DateRange,
): { date: string; time: string } | null {
  if (!dateRange.startDate) {
    return null;
  }
  const date = dateRange.endDate || dateRange.startDate;
  if (dateRange.allDay) {
    return { date, time: "23:59" };
  }
  if (dateRange.endTime) {
    return { date, time: dateRange.endTime };
  }
  // No end time: legacy shape (end = start). The writer refuses it for a date-model event and the form says why.
  return dateRange.startTime
    ? { date: dateRange.startDate, time: dateRange.startTime }
    : null;
}
